module.exports = __webpack_public_path__ + "media/app/assets/races/nightborne_female-d1f7b5aa0b5df1c13004ccee414ece55.png";